import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as Service from "../services";
import makeData from "../services/makeData";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";

import { COLUMNS } from "../config/Transaction/columns";
import { addAfterLoginNotification } from "../../../components/Toast/utils/notifications";

interface AsyncState {
  isLoading: {
    articleData: boolean;
    deleteArticle?: boolean;
    articleAdd?: boolean;
    articleImageAdd?: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface ArticleState extends AsyncState {
  articleData: any;
  articleImageAdd: string;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addArticleRes: any;
  deleteArticleRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  errorMsg?: any;
  userTableColumns: any;
}

const initialState: ArticleState = {
  isLoading: {
    articleData: true,
    deleteArticle: false,
    articleAdd: false,
    articleImageAdd: false,
  },
  isSuccess: false,
  isError: false,
  articleData: null,
  articleImageAdd: '',
  statusData: null,
  applicationOptions: null,
  addArticleRes: null,
  deleteArticleRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};

const articleDetails = {
  start_page: GENERAL.startPage,
  limit: GENERAL.itemsperpage,
  search: "",
  type: null,
  // price: { range: [GENERAL.priceMin, GENERAL.priceMax] },
  sort: "none",
};

export const fetchAllArticle = createAsyncThunk(
  "articleData",
  async (data: any, thunkAPI) => {
    try {
      const res: any = await Service.getAllArticles({
        ...articleDetails,
        ...data,
      });
      const madeData = makeData(res.data);
      return { madeData, totalCount: res.totalCounts, fullResponse: res.data };
    } catch (error: any) {
      // thunkAPI.dispatch(resetLogout(error))
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addArticle = createAsyncThunk(
  "user/addArticleData",
  async (data: any, thunkAPI) => {
    try {
      return await Service.addArticle(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addArticleImage = createAsyncThunk(
  "user/addArticleImage",
  async (data: any, thunkAPI) => {
    try {
      return await Service.addArticleImage(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
)

export const deleteArticle = createAsyncThunk(
  "user/deleteArticle",
  async (data: any, thunkAPI) => {
    try {
      return await Service.deleteArticle(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getColumns = createAsyncThunk(
  "getColumns",
  (data: any, thunkAPI) => {
    try {
      // const madeColsData = makeData(data);
      return data?.cols;
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const articleSlice = createSlice({
  name: "articles",
  initialState,
  reducers: {
    resetAddProductRes: (state) => {
      state.addArticleRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllArticle.pending, (state, action: any) => {
        state.isLoading.articleData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllArticle.fulfilled, (state, action: any) => {
        state.isLoading.articleData = false;
        state.isSuccess = true;
        state.isError = false;
        state.articleData = action.payload.madeData;
        state.totalCount = action.payload.totalCount;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllArticle.rejected, (state, action: any) => {
        state.isLoading.articleData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload,
        };
      })

      .addCase(addArticle.pending, (state) => {
        state.isLoading.articleAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.addArticleRes = null;
      })
      .addCase(addArticle.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Article Create successfully", "success");
        state.isLoading.articleAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.addArticleRes = action.payload;
      })
      .addCase(addArticle.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.articleAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.addArticleRes = null;
        state.errorMsg = action.payload.errorMsg;
      })

      //article image adding
      .addCase(addArticleImage.pending, (state) => {
        state.isLoading.articleImageAdd = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.articleImageAdd = '';
      })
      .addCase(addArticleImage.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Article Image Create successfully", "success");
        state.isLoading.articleImageAdd = false;
        state.isSuccess = true;
        state.isError = false;
        state.articleImageAdd = action.payload;
      })
      .addCase(addArticleImage.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.articleImageAdd = false;
        state.isSuccess = false;
        state.isError = true;
        state.articleImageAdd = '';
        state.errorMsg = action.payload.errorMsg;
      })

      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      })

      .addCase(deleteArticle.pending, (state) => {
        state.isLoading.deleteArticle = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMsg = null;
        state.deleteArticleRes = null;
      })
      .addCase(deleteArticle.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Article Deleted successfully", "success");
        state.isLoading.deleteArticle = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleteArticleRes = action.payload;
      })
      .addCase(deleteArticle.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteArticle = false;
        state.isSuccess = false;
        state.isError = true;
        state.deleteArticleRes = null;
        state.errorMsg = action.payload.errorMsg;
      });
  },
});
export const { resetAddProductRes } = articleSlice.actions;
export default articleSlice.reducer;
